import React, { useCallback, useEffect, useState } from 'react'
import m from 'moment'
import useAsync from 'Utils/hooks/useAsync'
import userInfoIntegration from 'Apis/integrations'
import { Modal } from 'semantic-ui-react'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import ItemDetailsModal from './ItemDetailsModal'
import ItemDetailsGenericModal from './ItemDetailsGenericModal'

const LinkExtra = styled.span`
  cursor: pointer;
  text-decoration: ${(props) => (props.textDecoration ? 'underline' : 'none')};
`
export const AssetNameSpan = styled.span`
  cursor: pointer;
  text-decoration: ${(props) => (props.textDecoration ? 'underline' : 'none')};
  margin-top: 5px;
  margin-left: 6px;
  font-size: 1.2em;
  font-weight: 600;
  white-space: nowrap;
  width: 100%;
  max-width: ${(props) => (props.chars || '22') + 'ch'};
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
`

export const ItemDetails = ({ id, assetId, assetName, spanStyle, chars }) => {
  const [open, setOpen] = useState(false)
  const [underline, setUnderline] = useState(false)
  const [dateRef, setDateRef] = useState('2022-07-27T23:59:00.000Z')
  const [loadingButton, setLoadingButton] = useState(false)
  const nfcId = useSelector((state) => state.assets.byId?.[assetId]?.info?.cardId)
  const tenant = useSelector((state) => state.login.empresa)
  const { execute, value, error } = useAsync(
    useCallback(() => userInfoIntegration.getUserInfoByNfc(nfcId, dateRef), [nfcId, dateRef]),
    false
  )

  const tryPreviousDate = useCallback(async () => {
    setLoadingButton(true)
    const newDate = await userInfoIntegration.getLatestDate(assetId, dateRef)
    setLoadingButton(false)
    setDateRef(newDate)
  }, [dateRef, assetId])

  const formattedDateRef = m(dateRef).format('lll')

  const handleOpenModal = useCallback(() => {
    execute()
    setOpen(true)
  }, [execute])

  useEffect(() => {
    if (open) {
      execute()
    }
  }, [open, execute, dateRef])

  return (
    <Modal
      onClose={() => setOpen(false)}
      onOpen={handleOpenModal}
      open={open}
      trigger={
        spanStyle !== 'popup' ? (
          <LinkExtra
            textDecoration={underline ? 'underline' : 'none'}
            onMouseEnter={() => setUnderline(true)}
            onMouseLeave={() => setUnderline(false)}
          >
            {assetName}
          </LinkExtra>
        ) : (
          <AssetNameSpan
            title={assetName}
            alt={assetName}
            textDecoration={underline ? 'underline' : 'none'}
            onMouseEnter={() => setUnderline(true)}
            onMouseLeave={() => setUnderline(false)}
            chars={chars}
          >
            {assetName}
          </AssetNameSpan>
        )
      }
    >
      {tenant === 'Tiplam' ? (
        <ItemDetailsModal
          id={nfcId}
          dateRef={formattedDateRef}
          value={value}
          setOpen={setOpen}
          error={error}
          tryPreviousDate={tryPreviousDate}
          loadingButton={loadingButton}
        />
      ) : (
        <ItemDetailsGenericModal
          id={nfcId}
          dateRef={formattedDateRef}
          setOpen={setOpen}
          assetId={assetId}
          assetName={assetName}
        />
      )}
    </Modal>
  )
}

export default ItemDetails
